import p1 from "../utils/assets/images/1.jpg";
import p2 from "../utils/assets/images/2.jpg";
import p3 from "../utils/assets/images/3.jpg";
import p4 from "../utils/assets/images/4.jpg";
import p5 from "../utils/assets/images/6.jpg";
import p6 from "../utils/assets/images/6.jpg";
import p7 from "../utils/assets/images/7.jpg";
import p8 from "../utils/assets/images/8.jpg";
import p9 from "../utils/assets/images/9.jpg";
import p10 from "../utils/assets/images/10.jpg";
import p11 from "../utils/assets/images/11.jpg";
import p12 from "../utils/assets/images/12.jpeg";
import p13 from "../utils/assets/images/13.png";
import p14 from "../utils/assets/images/14.jpeg";
import p15 from "../utils/assets/images/15.jpg";
import p16 from "../utils/assets/images/16.jpg";


const cardData=[
    {
        id:1,
        img:p1,
        title:'NewsPaper, Copies/Books, Cardboard',
        buyRate:15,
        sellRate:20,
        amount:15,
       
    },
    {
        id:2,
        img:p2,
        title:'Plastic/ Iron/ Steel/ Aluminium, Brass, Copper',
        buyRate:15,
        sellRate:20,
        amount:13,
    
    },
    {
        id:3,
        img:p3,
        title:'Iron Cooler, Plastic Cooler',
        buyRate:15,
        sellRate:20,
        amount:20,
       
    },
    {
        id:4,
        img:p4,
        title:'Window AC Aluminium(1.5 Ton)',
        buyRate:15,
        sellRate:20,
        amount:10,
    },
    {
        id:5,
        img:p5,
        title:'Front Load Fully Automatic Washing Machine',
        buyRate:15,
        sellRate:20,
        amount:30,
        
    },
    {
        id:6,
        img:p6,
        title:'Top Load Fully Automatic Washing Machine',
        buyRate:15,
        sellRate:20,
        amount:10,
       
    },
    {
        id:7,
        img:p7,
        title:'Semi Automatic Washing Machine(Double Drum)',
        buyRate:15,
        sellRate:20,
        amount:20,
       
    },
    {
        id:8,
        img:p8,
        title:'Geyser, Single Door Fridge, Double Door Fridge',
        buyRate:15,
        sellRate:20,
        amount:25,
        
    },
    {
        id:9,
        img:p9,
        title:'AC(2 Ton), AC Copper(1.5 Ton), AC(1 Ton)',
        buyRate:15,
        sellRate:20,
        amount:20,
        
    },
    {
        id:10,
        img:p10,
        title:'Heavy E-waste (content: metal>plastic)',
        buyRate:15,
        sellRate:20,
        amount:30,
       
    },
    {
        id:11,
        img:p11,
        title:'Light-waste (content: plastic>metal)',
        buyRate:15,
        sellRate:20,
        amount:35,
      
    },
    {
        id:12,
        img:p12,
        title:'Printers, scanner/fax machine, crt tv, ceiling fan',
        buyRate:15,
        sellRate:20,
        amount:20,
       
    },
    {
        id:13,
        img:p13,
        title:'motors (copper wiring), microwave, ups',
        buyRate:15,
        sellRate:20,
        amount:20,
      
    },
    {
        id:14,
        img:p14,
        title:'inverters.stabilizer (copper coil)',
        buyRate:15,
        sellRate:20,
        amount:20,
       
    },
    {
        id:15,
        img:p15,
        title:'battery (used with inverters) ,tablet, laptop',
        buyRate:15,
        sellRate:20,
        amount:20,
       
    },
    {
        id:16,
        img:p16,
        title:'crt monitor, lcd monitor, computer cpu',
        buyRate:15,
        sellRate:20,
        amount:20,
        
    },
 
];

export default cardData;